import moneyInputComponent from './components/money.input.component';
import moneyComponent from './components/money.component';

import moneyInputController from './controllers/money.input.controller';
import moneyController from './controllers/money.controller';

import imgixSrcDirective from './directives/imgixSrc.directive';
import imgixRefreshDirective from './directives/imgix.refresh.directive';

import configService from './services/config.service';
import storeService from './services/store.service';
import imgixService from './services/imgix.service';
import timeService from './services/time.service';
import moneyService from './services/money.service';
import dateService from './services/date.service';
import loadingService from './services/loading.service';

let sharedBaseModule = angular.module('spabooker.shared.base', [])
    .component('moneyInput', moneyInputComponent)
    .component('money', moneyComponent)

    .controller('moneyInputController', moneyInputController)
    .controller('moneyController', moneyController)

    .directive('imgixSrc', imgixSrcDirective)
    .directive('imgixRefresh', imgixRefreshDirective)

    .factory('configService', configService)
    .factory('storeService', storeService)
    .factory('imgix', imgixService)
    .factory('time', timeService)
    .factory('moneyService', moneyService)
    .factory('dateService', dateService)
    .factory('loadingService', loadingService)
    ;

export default sharedBaseModule.name;



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/shared/base/index.js